"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenericCameraSourceSettings = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../../hooks");
var _JoinComponent = require("../../Join/JoinComponent.styled");
var _MicrophoneSelector = require("../../Join/PageBody/MicrophoneSelector");
var _CheckAudioOutput = require("../../Join/PageBody/CheckAudioOutput");
var _CameraSelectorSwitch = require("../../Join/PageBody/CameraSelectorSwitch");
var _VirtualBackgroundOptions = require("../../Join/VirtualBackgroundOptions/VirtualBackgroundOptions");
var _useBackgroundFilterPageActionsApi = require("@studio/metrics/client/react/useBackgroundFilterPageActionsApi");
var _VirtualBackground = require("@studio/constants/VirtualBackground");
var _GenericCameraPreview = require("../../Join/GenericCameraPreview/GenericCameraPreview");
var _PageBody = require("../../Join/PageBody/PageBody");
var _ = require("../..");
var _StudioLogger = require("@studio/logger/StudioLogger");
var _utils = require("../../Join/utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../../constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t5 in e) "default" !== _t5 && {}.hasOwnProperty.call(e, _t5) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t5)) && (i.get || i.set) ? o(f, _t5, i) : f[_t5] = e[_t5]); return f; })(e, t); }
var LOG = new _StudioLogger.StudioLogger('generic-source-settings');

/**
 * GenericCameraSourceSettings component for configuring camera, microphone, audio output, and virtual background settings.
 *
 */
var GenericCameraSourceSettings = exports.GenericCameraSourceSettings = function GenericCameraSourceSettings(_ref) {
  var _virtualBackground$im, _selectedVideoInput$v;
  var _title = _ref.title,
    _description = _ref.description,
    onSubmit = _ref.onSubmit,
    onCancel = _ref.onCancel,
    audioInputDeviceId = _ref.audioInputDeviceId,
    audioOutputDeviceId = _ref.audioOutputDeviceId,
    videoInput = _ref.videoInput,
    user = _ref.user,
    uploadUserVirtualBackground = _ref.uploadUserVirtualBackground,
    saveUserVirtualBackground = _ref.saveUserVirtualBackground,
    resetUserVirtualBackground = _ref.resetUserVirtualBackground,
    initializeBackgroundFilter = _ref.initializeBackgroundFilter,
    switchAudioInput = _ref.switchAudioInput,
    client = _ref.client,
    _ref$CameraPreviewEle = _ref.CameraPreviewElement,
    CameraPreviewElement = _ref$CameraPreviewEle === void 0 ? _GenericCameraPreview.GenericCameraPreview : _ref$CameraPreviewEle,
    _ref$dispatch = _ref.dispatch,
    dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch,
    _ref$deviceActions = _ref.deviceActions,
    deviceActions = _ref$deviceActions === void 0 ? {} : _ref$deviceActions,
    changeVideoInputDevice = _ref.changeVideoInputDevice,
    changeUserBackground = _ref.changeUserBackground,
    updateVideoInput = _ref.updateVideoInput;
  var _useState = (0, _react.useState)(videoInput),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selectedVideoInput = _useState2[0],
    setSelectedVideoInput = _useState2[1];
  var _useState3 = (0, _react.useState)(audioInputDeviceId),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    selectedAudioInputId = _useState4[0],
    setSelectedAudioInputId = _useState4[1];
  var _useState5 = (0, _react.useState)(audioOutputDeviceId),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    selectedAudioOutputId = _useState6[0],
    setSelectedAudioOutputId = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    isCancelInProgress = _useState8[0],
    setIsCancelInProgress = _useState8[1];
  var _useState9 = (0, _react.useState)(_description),
    _useState0 = (0, _slicedToArray2["default"])(_useState9, 2),
    description = _useState0[0],
    setDescription = _useState0[1];
  var _useState1 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2["default"])(_useState1, 1),
    isVideoDisconnected = _useState10[0];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    userBackgroundLoading = _useState12[0],
    setUserBackgroundLoading = _useState12[1];
  var _useState13 = (0, _react.useState)("".concat(_title)),
    _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
    title = _useState14[0],
    setTitle = _useState14[1];
  var _getUserNameFromPrese = (0, _utils.getUserNameFromPresenterTitle)(title),
    firstName = _getUserNameFromPrese.firstName,
    lastName = _getUserNameFromPrese.lastName;
  var virtualBackground = user === null || user === void 0 ? void 0 : user.virtualBackground;
  var backgroundUrl = (_virtualBackground$im = virtualBackground === null || virtualBackground === void 0 ? void 0 : virtualBackground.imageURL) !== null && _virtualBackground$im !== void 0 ? _virtualBackground$im : '';
  var initialVirtualBackgroundRef = (0, _react.useRef)(virtualBackground);
  var _useState15 = (0, _react.useState)({
      device: null,
      virtualBackground: null,
      virtualBackgroundImageUrl: null
    }),
    _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
    initialVideoInput = _useState16[0],
    setInitialVideoInput = _useState16[1];
  var _useBackgroundFilterP = (0, _useBackgroundFilterPageActionsApi.useBackgroundFilterPageActionsApi)(),
    startAttendeeBackgroundFilterChangeLatency = _useBackgroundFilterP.startAttendeeBackgroundFilterChangeLatency,
    endAttendeeBackgroundFilterChangeLatency = _useBackgroundFilterP.endAttendeeBackgroundFilterChangeLatency;
  var isVideoTurnedOffOnEntryRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var _videoInput$videoTrac;
    setInitialVideoInput(videoInput);
    isVideoTurnedOffOnEntryRef.current = ((_videoInput$videoTrac = videoInput.videoTrack) === null || _videoInput$videoTrac === void 0 ? void 0 : _videoInput$videoTrac.enabled) === false;
  }, []);
  (0, _react.useEffect)(function () {
    setSelectedVideoInput(videoInput);
  }, [videoInput]);
  var _useGetMediaDevices = (0, _hooks.useGetMediaDevices)({
      audio: true,
      video: true
    }),
    audioInputDevices = _useGetMediaDevices.audioInputDevices,
    audioOutputDevices = _useGetMediaDevices.audioOutputDevices,
    videoInputDevices = _useGetMediaDevices.videoInputDevices;
  (0, _react.useEffect)(function () {
    if (audioOutputDevices.length > 0) {
      var _audioOutputDevices$;
      var _selectedAudioOutputId = (_audioOutputDevices$ = audioOutputDevices[0]) === null || _audioOutputDevices$ === void 0 ? void 0 : _audioOutputDevices$.value;
      if (_selectedAudioOutputId) {
        setSelectedAudioOutputId(_selectedAudioOutputId);
      }
    }
  }, [videoInputDevices, audioInputDevices, audioOutputDevices]);
  (0, _react.useEffect)(function () {
    if (!isCancelInProgress && !backgroundUrl && selectedVideoInput.virtualBackground === _VirtualBackground.BACKGROUND_OPTIONS.CUSTOM && selectedVideoInput.virtualBackgroundImageUrl) {
      onVirtualBackgroundChange(_VirtualBackground.BACKGROUND_OPTIONS.CUSTOM, backgroundUrl);
    }
  }, [backgroundUrl]);
  var videoDevices = videoInputDevices;
  var audioInputDevicesList = audioInputDevices;
  var onVideoInputChange = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(videoInputDevice) {
      var _videoInput, _t;
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setUserBackgroundLoading(true);
            _context.next = 1;
            return changeVideoInputDevice(selectedVideoInput, videoInputDevice);
          case 1:
            _videoInput = _context.sent;
            setSelectedVideoInput(_videoInput);
            updateVideoInput(_videoInput);
            _context.next = 3;
            break;
          case 2:
            _context.prev = 2;
            _t = _context["catch"](0);
            LOG.error('Error changing video input:', _t);
          case 3:
            _context.prev = 3;
            setUserBackgroundLoading(false);
            return _context.finish(3);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 2, 3, 4]]);
    }));
    return function onVideoInputChange(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var onVirtualBackgroundChange = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(backgroundOption) {
      var url,
        _videoInput,
        _args2 = arguments,
        _t2;
      return _regenerator["default"].wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            url = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : backgroundUrl;
            _context2.prev = 1;
            setUserBackgroundLoading(true);
            startAttendeeBackgroundFilterChangeLatency({
              filterTypeBefore: selectedVideoInput.virtualBackground,
              filterTypeAfter: backgroundOption
            });
            _context2.next = 2;
            return changeUserBackground(selectedVideoInput, backgroundOption, url);
          case 2:
            _videoInput = _context2.sent;
            setSelectedVideoInput(_videoInput);
            updateVideoInput(_videoInput);
            endAttendeeBackgroundFilterChangeLatency();
            _context2.next = 4;
            break;
          case 3:
            _context2.prev = 3;
            _t2 = _context2["catch"](1);
            endAttendeeBackgroundFilterChangeLatency({
              error: "Error updating virtual background : ".concat(_t2.message)
            });
            LOG.error('Error updating virtual background:', _t2);
          case 4:
            _context2.prev = 4;
            setUserBackgroundLoading(false);
            return _context2.finish(4);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 3, 4, 5]]);
    }));
    return function onVirtualBackgroundChange(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleUploadFile = function handleUploadFile(file) {
    resetUserVirtualBackground();
    uploadUserVirtualBackground(file);
  };
  var hasTitle = title.trim().length > 0;
  var hasDescriptionExceededLimit = description.trim().length > 80;
  var hasFirstNameExceededLimit = firstName.trim().length > 30;
  var hasLastNameExceededLimit = lastName.trim().length > 50;
  var hasValidationError = !hasTitle || hasDescriptionExceededLimit || hasFirstNameExceededLimit || hasLastNameExceededLimit;
  var initialDeviceId = initialVideoInput.device,
    initialUserBackground = initialVideoInput.virtualBackground,
    initialUserBackgroundUrl = initialVideoInput.virtualBackgroundImageUrl;
  var selectedDeviceId = selectedVideoInput.device,
    selectedUserBackground = selectedVideoInput.virtualBackground,
    selectedUserBackgroundUrl = selectedVideoInput.virtualBackgroundImageUrl;
  var didVirtualBackgroundChange = initialUserBackground !== selectedUserBackground;
  var didVideoInputChange = initialDeviceId !== selectedDeviceId;
  var didBackgroundUrlChange = initialUserBackgroundUrl !== selectedUserBackgroundUrl;
  var handleSubmit = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(event) {
      var audioSettingsChanged, hasBackgroundUrl, fileName, relativePath, changes, videoSettingsChanged, _t3;
      return _regenerator["default"].wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            event.preventDefault();

            // if video input was turned off on entry, it should be turned back off on submit
            if (!(isVideoTurnedOffOnEntryRef.current && selectedVideoInput.videoTrack)) {
              _context3.next = 4;
              break;
            }
            _context3.prev = 1;
            _context3.next = 2;
            return selectedVideoInput.videoTrack.setEnabled(false);
          case 2:
            _context3.next = 4;
            break;
          case 3:
            _context3.prev = 3;
            _t3 = _context3["catch"](1);
            LOG.error('Error disabling video track on submit:', _t3);
          case 4:
            audioSettingsChanged = selectedAudioInputId !== '' && selectedAudioInputId !== audioInputDeviceId;
            if (!audioSettingsChanged) {
              _context3.next = 5;
              break;
            }
            _context3.next = 5;
            return switchAudioInput(client, selectedAudioInputId, dispatch, deviceActions);
          case 5:
            if (selectedVideoInput.virtualBackground === _VirtualBackground.BACKGROUND_OPTIONS.CUSTOM) {
              hasBackgroundUrl = !!selectedUserBackgroundUrl;
              if (hasBackgroundUrl) {
                fileName = virtualBackground.fileName, relativePath = virtualBackground.relativePath;
                saveUserVirtualBackground(fileName, relativePath);
              } else {
                saveUserVirtualBackground();
                resetUserVirtualBackground();
              }
            }
            onSubmit({
              audioInputDeviceId: selectedAudioInputId,
              audioOutputDeviceId: selectedAudioOutputId,
              title: title,
              description: description
            });
            changes = {};
            videoSettingsChanged = didVideoInputChange || didVirtualBackgroundChange || didBackgroundUrlChange;
            if (title !== _title) changes.title = title;
            if (description !== _description) changes.description = description;
            if (videoSettingsChanged) changes.videoInput = selectedVideoInput;
            if (selectedAudioInputId !== audioInputDeviceId) changes.audioInput = selectedAudioInputId;
            LOG.info("CameraSourceSettings - ".concat(title, " updated settings"), changes);
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 3]]);
    }));
    return function handleSubmit(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleCancel = /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var _videoInput, _t4;
      return _regenerator["default"].wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            setIsCancelInProgress(true);
            _context4.prev = 1;
            // If user changed the background (uploaded new or deleted), restore the original
            if (selectedUserBackgroundUrl !== initialUserBackgroundUrl) {
              resetUserVirtualBackground(initialVirtualBackgroundRef.current);
            }
            _videoInput = selectedVideoInput;
            if (!didVideoInputChange) {
              _context4.next = 3;
              break;
            }
            _context4.next = 2;
            return changeVideoInputDevice(selectedVideoInput, initialDeviceId);
          case 2:
            _videoInput = _context4.sent;
          case 3:
            if (!(didVirtualBackgroundChange || didBackgroundUrlChange)) {
              _context4.next = 5;
              break;
            }
            _context4.next = 4;
            return changeUserBackground(_videoInput, initialUserBackground, initialUserBackgroundUrl);
          case 4:
            _videoInput = _context4.sent;
          case 5:
            if (!(isVideoTurnedOffOnEntryRef.current && _videoInput.videoTrack)) {
              _context4.next = 6;
              break;
            }
            _context4.next = 6;
            return _videoInput.videoTrack.setEnabled(false);
          case 6:
            updateVideoInput(_videoInput);
            _context4.next = 8;
            break;
          case 7:
            _context4.prev = 7;
            _t4 = _context4["catch"](1);
            LOG.error('Error reverting video input changes on cancel:', _t4);
          case 8:
            _context4.prev = 8;
            setIsCancelInProgress(false);
            onCancel();
            return _context4.finish(8);
          case 9:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[1, 7, 8, 9]]);
    }));
    return function handleCancel() {
      return _ref5.apply(this, arguments);
    };
  }();
  var isCancelDisabled = isCancelInProgress || isVideoDisconnected || userBackgroundLoading;
  var isSubmitDisabled = hasValidationError || isCancelInProgress || userBackgroundLoading;
  var disableInput = false;
  var disableVideoInput = userBackgroundLoading || disableInput;
  var _userBackground = (_selectedVideoInput$v = selectedVideoInput === null || selectedVideoInput === void 0 ? void 0 : selectedVideoInput.virtualBackground) !== null && _selectedVideoInput$v !== void 0 ? _selectedVideoInput$v : _VirtualBackground.BACKGROUND_OPTIONS.NONE;
  var hasCamera = (0, _utils.hasCameraDevices)(videoInputDevices);
  return /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardBody, null, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardTitleContainer, null, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardTitle, {
    tag: "h4"
  }, "Settings")), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledSettingsComponentContent, null, /*#__PURE__*/_react["default"].createElement(_PageBody.PageBody, {
    presenterTitle: title,
    presenterDescription: description,
    setPresenterTitle: setTitle,
    setPresenterDescription: setDescription,
    microphoneSelector: /*#__PURE__*/_react["default"].createElement(_MicrophoneSelector.MicrophoneSelector, {
      selectedAudioInputDevice: selectedAudioInputId,
      audioInputDevices: audioInputDevicesList,
      onMicrophoneChange: setSelectedAudioInputId,
      disabled: disableInput
    }),
    checkAudioOutput: /*#__PURE__*/_react["default"].createElement(_CheckAudioOutput.CheckAudioOutput, {
      audioOutputDevice: selectedAudioOutputId,
      disabled: disableInput
    }),
    cameraSelector: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_CameraSelectorSwitch.CameraSelectorSwitch, {
      selectedVideoInput: selectedVideoInput,
      videoInputDevices: videoDevices,
      onCameraChange: onVideoInputChange,
      disabled: disableVideoInput,
      initializeBackgroundFilter: initializeBackgroundFilter
    }, hasCamera && /*#__PURE__*/_react["default"].createElement(_VirtualBackgroundOptions.VirtualBackgroundOptions, {
      userBackground: _userBackground,
      updateUserBackground: onVirtualBackgroundChange,
      uploadUserVirtualBackground: handleUploadFile,
      virtualBackground: virtualBackground,
      resetUserVirtualBackground: resetUserVirtualBackground,
      isCustomBackgroundProcessing: userBackgroundLoading
    }))),
    cameraPreview: /*#__PURE__*/_react["default"].createElement(CameraPreviewElement, {
      presenterTitle: title,
      presenterDescription: description,
      videoInputDevice: selectedVideoInput,
      checkStatus: _constants.JOIN_PAGE_STATUS.COMPLETE
    }),
    checkStatus: "READY",
    readinessCheck: {}
  })), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardFooter, null, /*#__PURE__*/_react["default"].createElement(_.Button, {
    onClick: handleCancel,
    color: "outline",
    className: "me-2",
    "data-testid": "cancel",
    disabled: isCancelDisabled
  }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_.Button, {
    disabled: isSubmitDisabled,
    onClick: handleSubmit,
    color: "primary",
    "data-testid": "submit"
  }, "Done")));
};
GenericCameraSourceSettings.propTypes = {
  title: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string.isRequired,
  onSubmit: _propTypes["default"].func.isRequired,
  onCancel: _propTypes["default"].func.isRequired,
  audioInputDeviceId: _propTypes["default"].string,
  audioOutputDeviceId: _propTypes["default"].string,
  videoInputDeviceId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  userBackground: _propTypes["default"].oneOf([_VirtualBackground.BACKGROUND_OPTIONS.NONE, _VirtualBackground.BACKGROUND_OPTIONS.BLUR, _VirtualBackground.BACKGROUND_OPTIONS.CUSTOM]),
  transformedVideoInputs: _propTypes["default"].array,
  user: _propTypes["default"].object,
  uploadUserVirtualBackground: _propTypes["default"].func,
  saveUserVirtualBackground: _propTypes["default"].func,
  resetUserVirtualBackground: _propTypes["default"].func,
  initializeBackgroundFilter: _propTypes["default"].func.isRequired,
  switchAudioInput: _propTypes["default"].func.isRequired,
  currentVideoTrack: _propTypes["default"].object,
  client: _propTypes["default"].object.isRequired,
  CameraPreviewElement: _propTypes["default"].elementType,
  attendeeId: _propTypes["default"].string,
  dispatch: _propTypes["default"].func,
  deviceActions: _propTypes["default"].object,
  changeVideoInputDevice: _propTypes["default"].func.isRequired,
  changeUserBackground: _propTypes["default"].func.isRequired,
  updateVideoInput: _propTypes["default"].func.isRequired
};